import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";
import { readFileSync } from "fs";

export class FileService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  uploadPropmt = async (session_id, file) => {
    try {
      return await this.HttpService.uploadFile(
        this.constants.fileServicesURLs.uploadPrompt,
        file,
        session_id,
        {}
      );
    } catch (e) {
      throw e;
    }
  };

  uploadCallFlow = async (session_id, file) => {
    try {
      return await this.HttpService.uploadFile(
        this.constants.fileServicesURLs.uploadCallFlow,
        file,
        session_id,
        {}
      );
    } catch (e) {
      throw e;
    }
  };

  uploadDevelopedCallFlow = async (session_id, fileCTI, fileWeb) => {
    try {
      return await this.HttpService.uploadMultipleFile(
        this.constants.fileServicesURLs.uploadDevelopedCallFlow,
        fileCTI,
        fileWeb,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  editDevelopedCallFlow = async (session_id, fileCTI, fileWeb,fileId) => {
    try {
      let additionalData = {
        fileId: fileId
      }
      return await this.HttpService.uploadMultipleFile(
        this.constants.fileServicesURLs.editDevelopedCallFlow,
        fileCTI,
        fileWeb,
        session_id,
        additionalData
        );
    } catch (e) {
      throw e;
    }
  };
  uploadProfileImg = async (session_id, file) => {
    try {
      return await this.HttpService.uploadFile(
        this.constants.fileServicesURLs.uploadProfileImg,
        file,
        session_id,
        {}
      );
    } catch (e) {
      throw e;
    }
  };

  uploadMsisdnBatch = async (session_id, file) => {
    try {
      return await this.HttpService.uploadFile(
        this.constants.fileServicesURLs.uploadMsisdnFile,
        file,
        session_id,
        {}
      );
    } catch (e) {
      throw e;
    }
  };
  getPromptsService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.fileServicesURLs.getPrompts,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getCallFlowsService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.fileServicesURLs.getCallFlows,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  downloadPrompt = async (session_id, item) => {
    try {
      let file = await this.HttpService.downloadFile(
        this.constants.fileServicesURLs.downloadPrompt + `${item.fileId}`,
        session_id
      );

      var a = window.document.createElement("a");

      a.href = file;
      a.download = item.name;

      // Append anchor to body.
      document.body.appendChild(a);
      a.click();

      // Remove anchor from body
      document.body.removeChild(a);
    } catch (e) {
      throw e;
    }
  };

  downloadCallFlow = async (session_id, item) => {
    try {
      let blob = await this.HttpService.downloadCallFlowFile(
        this.constants.fileServicesURLs.downloadDevelopedCallFlow +
          `${item.fileId}`,
        session_id
      );
      // var a = window.document.createElement("a");

      // a.href = file;
      // a.download = item.name;

      // // Append anchor to body.
      // document.body.appendChild(a);
      // a.click();

      // // Remove anchor from body
      // document.body.removeChild(a);
      return blob;
    } catch (e) {
      throw e;
    }
  };

  downloadVoiceMail = async (session_id, file_id) => {
    try {
      return await this.HttpService.downloadFile(
        this.constants.fileServicesURLs.downloadVoiceMail + `${file_id}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  downloadCallRecord = async (session_id, file_id) => {
    try {
      return await this.HttpService.downloadFile(
        this.constants.fileServicesURLs.downloadCallRecord + `${file_id}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  downloadPromptToPlay = async (session_id, fileId) => {
    try {
      return await this.HttpService.downloadFile(
        this.constants.fileServicesURLs.downloadPrompt + `${fileId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getUserImg = async (session_id, user_id) => {
    try {
      return await this.HttpService.downloadFile(
        this.constants.fileServicesURLs.getUserImg + `${user_id}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  deleteUserImg = async (session_id, user_id) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.fileServicesURLs.deleteUserImg + `${user_id}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  assignCallFlow = async (session_id, fileId) => {
    try {
      return await this.HttpService.postJson(
        this.constants.fileServicesURLs.assignCallFlow,
        {
          fileId: fileId,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteCallFlow = async (session_id, item) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.fileServicesURLs.deleteCallFlow + `${item.fileId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deletePrompt = async (session_id, item) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.fileServicesURLs.deletePrompt + `${item.fileId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  downloadMsisdnTemp = async (session_id, fileId) => {
    try {
      let file = await this.HttpService.downloadFile(
        this.constants.fileServicesURLs.downloadMsisdnTemp + `${fileId}`,
        session_id
      );

      var a = window.document.createElement("a");

      a.href = file;
      a.download = "msisdnBatch.csv";

      // Append anchor to body.
      document.body.appendChild(a);
      a.click();

      // Remove anchor from body
      document.body.removeChild(a);
    } catch (e) {
      throw e;
    }
  };
}
